export default __webpack_public_path__ + "static/saf-webfont-053f326b7d69b9350be36ab133f1cdcc.woff2";